import { render, staticRenderFns } from "./summary_trucktrack.vue?vue&type=template&id=18cb5d48&scoped=true&"
import script from "./summary_trucktrack.vue?vue&type=script&lang=js&"
export * from "./summary_trucktrack.vue?vue&type=script&lang=js&"
import style0 from "./summary_trucktrack.vue?vue&type=style&index=0&id=18cb5d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb5d48",
  null
  
)

export default component.exports